import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Barter List]'

export const setItemCollection = createAction(
    `${ SOURCE } SetItemCollection`, props<{ itemCollection: any[] }>(),
)
export const setFilterCriteria = createAction(
    `${ SOURCE } SetFilterCriteria`, props<{ filterCriteria: any }>(),
)
export const setFilter = createAction(
    `${ SOURCE } SetFilter`, props<{ filter: any }>(),
)
export const updateFilterCriteria = createAction(
    `${ SOURCE } UpdateFilterCriteria`, props<{ criteriaFragment: any }>(),
)
export const updateFilterCriteriaAndFilter = createAction(
    `${ SOURCE } UpdateFilterCriteriaAndFilter`, props<{ criteriaFragment: any }>(),
)
export const noAction = createAction(
    `${ SOURCE } No Action`,
)
export const filter = createAction(
    `${ SOURCE } Filter`,
)
export const setStoredOrDefaultCriteria = createAction(
    `${ SOURCE } SetStoredOrDefaultCriteria`,
)
export const resetItemCollection = createAction(
    `${ SOURCE } ResetItemCollection`,
)
export const resetFilterCriteria = createAction(
    `${ SOURCE } ResetFilterCriteria`,
)
export const resetFilter = createAction(
    `${ SOURCE } ResetFilter`,
)

